import { Injectable } from '@angular/core';
import { ToastItem, ToastLevel } from '@app/models/toast.model';
import { BehaviorSubject } from 'rxjs';
import { v4 as uuid } from 'uuid';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly toastsSubject = new BehaviorSubject<ToastItem[]>([]);
  readonly toasts = this.toastsSubject.asObservable();

  show(
    message: string,
    level: ToastLevel = 'info',
    options: Partial<ToastItem> = {}
  ): string {
    const toast: ToastItem = {
      id: uuid(),
      message,
      level,
      autohide: options.autohide ?? true,
      delay: options.delay ?? 3000,
      ...options,
    };

    const currentToasts = this.toastsSubject.value;
    this.toastsSubject.next([toast, ...currentToasts]);

    if (toast.autohide) {
      const delayMs = typeof toast.delay === 'number' ? toast.delay : 3000;
      window.setTimeout(() => this.remove(toast.id), delayMs);
    }

    return toast.id;
  }

  success(message: string, options?: Partial<ToastItem>) {
    return this.show(message, 'success', options);
  }
  error(message: string, options?: Partial<ToastItem>) {
    return this.show(message, 'danger', options);
  }
  info(message: string, options?: Partial<ToastItem>) {
    return this.show(message, 'info', options);
  }
  warn(message: string, options?: Partial<ToastItem>) {
    return this.show(message, 'warning', options);
  }

  remove(toastId: string): void {
    const currentToasts = this.toastsSubject.value;
    const remainingToasts = currentToasts.filter(
      (toast) => toast.id !== toastId
    );
    this.toastsSubject.next(remainingToasts);
  }

  clear(): void {
    this.toastsSubject.next([]);
  }
}
